'use es6';

import styled from 'foundations-theming/utils';
import UIButton from 'UIComponents/button/UIButton';
export default styled(UIButton).withConfig({
  displayName: "StyleProtectedMenuButton",
  componentId: "ljnad5-0"
})(["color:", " !important;background-color:", " !important;&:hover{background-color:", " !important;}"], ({
  theme
}) => theme.color['do-not-use-obsidian'], ({
  theme
}) => theme.color['do-not-use-olaf'], ({
  theme
}) => theme.color['do-not-use-calypso-light']);